import { useTranslation } from 'react-i18next';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
  HStack,
  Spinner,
  Text,
} from '@shared/ui';

export function SpinnerShowcase() {
  const { t } = useTranslation();

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t('uiLibrary.feedback.spinner.title')}</CardTitle>
        <CardDescription>{t('uiLibrary.feedback.spinner.description')}</CardDescription>
      </CardHeader>
      <CardContent>
        <HStack gap="lg" className="flex-wrap">
          <HStack gap="sm">
            <Spinner size="sm" aria-label={t('uiLibrary.feedback.spinner.ariaLabel')} />
            <Text size="sm">{t('uiLibrary.feedback.spinner.sizes.sm')}</Text>
          </HStack>
          <HStack gap="sm">
            <Spinner size="md" aria-label={t('uiLibrary.feedback.spinner.ariaLabel')} />
            <Text size="sm">{t('uiLibrary.feedback.spinner.sizes.md')}</Text>
          </HStack>
          <HStack gap="sm">
            <Spinner size="lg" aria-label={t('uiLibrary.feedback.spinner.ariaLabel')} />
            <Text size="sm">{t('uiLibrary.feedback.spinner.sizes.lg')}</Text>
          </HStack>
        </HStack>
      </CardContent>
    </Card>
  );
}
